import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { COMPANY } from '@/constants/company';

const navItems = [
  { label: 'ホーム', path: '/' },
  { label: 'サービス', path: '/services' },
  { label: '地域力', path: '/regional' },
  { label: 'お客様の声', path: '/testimonials' },
  { label: 'FAQ', path: '/faq' },
  { label: '会社概要', path: '/company' },
  { label: '物件一覧', path: '/listings' },
  { label: 'AI査定', path: '/ai-satei' },
  { label: 'お問い合わせ', path: '/contact' },
];

// ダーク背景FVがあるページ（透明ヘッダーを使うページ）
const DARK_HERO_PAGES = ['/', '/ai-satei'];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  const hasDarkHero = DARK_HERO_PAGES.includes(location.pathname);
  const isLight = !hasDarkHero || scrolled;

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
    setScrolled(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isLight ? 'bg-white border-b border-gray-100 shadow-sm' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8 flex items-center justify-between h-16 md:h-20">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-2 cursor-pointer">
          <div className="w-8 h-8 bg-[#1A2B4A] rounded flex items-center justify-center">
            <span className="text-white text-xs font-bold">CC</span>
          </div>
          <span className={`font-bold text-sm md:text-base whitespace-nowrap transition-colors duration-300 ${isLight ? 'text-[#1A2B4A]' : 'text-white'}`}>
            {COMPANY.name}
          </span>
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden lg:flex items-center gap-6">
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`text-sm whitespace-nowrap transition-colors duration-200 hover:text-[#4A90E2] ${
                location.pathname === item.path
                  ? 'text-[#4A90E2] font-medium'
                  : isLight
                  ? 'text-[#1A2B4A]'
                  : 'text-white'
              }`}
            >
              {item.label}
            </Link>
          ))}
        </nav>

        {/* Hamburger */}
        <div className="flex items-center gap-3">
          <button
            className="lg:hidden w-8 h-8 flex items-center justify-center cursor-pointer"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="メニュー"
          >
            <i className={`text-xl transition-colors duration-300 ${isLight ? 'text-[#1A2B4A]' : 'text-white'} ${menuOpen ? 'ri-close-line' : 'ri-menu-line'}`} />
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="lg:hidden bg-white border-t border-gray-100">
          <nav className="max-w-7xl mx-auto px-4 py-4 flex flex-col gap-1">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`py-3 px-4 rounded-lg text-sm font-medium transition-colors duration-200 cursor-pointer ${
                  location.pathname === item.path
                    ? 'bg-[#F0F4FA] text-[#1A2B4A]'
                    : 'text-gray-700 hover:bg-gray-50'
                }`}
              >
                {item.label}
              </Link>
            ))}
            <a
              href={COMPANY.telHref}
              className="mt-2 py-3 px-4 rounded-lg text-sm font-medium text-[#1A2B4A] border border-[#1A2B4A] text-center cursor-pointer"
            >
              <i className="ri-phone-line mr-2" />
              {COMPANY.tel}（{COMPANY.hours}）
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}
